<template>
  <div class="listmx">
    <van-nav-bar
      :title="'监考明细('+list.length+')'"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <van-list
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
    <van-row v-for="(item,index) in list" :key="index" class="mxitem" >
      <van-col span="14">
        <p>
          <img  v-if="item.cameraurl != null" :src="item.cameraurl" height="150" width="150"/>
          <img v-if="item.cameraurl==null" src="../../assets/img/head.jpeg" height="150" width="150"/>
        </p>

      </van-col>
      <van-col span="9">
        <h4>考生：{{ item.studentname }}</h4>
       <p>考试时长：{{ item.examTime }} 分钟</p>
        <p v-if="item.ssjj != 'Y'" v-html="item.ksbj=='Y'?'状态：<font color=green>正在考试...</font>':'状态：<font color=red>未进入考试</font>'"> </p>
        <p v-html="item.ssjj=='Y'?'交卷状态：<font color=green>已交卷</font>':'交卷状态：<font color=red>未交卷</font>'"></p>
        <p v-html="'已答题：<font color=green>'+(item.ydt==null ||  item.ydt=='' ? '0' : item.ydt)+'</font>'"></p>
        <p v-html="'未答题：<font color=red>'+(item.wdt==null || item.wdt=='' ? '0' : item.wdt)+'</font>'"></p>
        <p v-html="'延时：'+(item.ystime==null||item.ystime==''?'<font color=green>0</font>' : '<font color=red>'+item.ystime+'</font>')+'分钟'"></p>
      </van-col>
      <van-col span="24">
        <div
          class="enter"
        ><a v-if="item.ssjj=='Y'?false:true" @click="jjsubmit(item.ksmxid)">强制交卷</a>  <a @click="ysshowbt(item.ksmxid,item.studentnumber,item.studentname)" v-if="item.ssjj=='Y'?false:true">延时</a> <a @click="ckshowbt(item.ksmxid,item.studentnumber,item.studentname)">重考</a>
        </div>
      </van-col>
    </van-row>
    </van-list>
    <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
    <!--重考申请-->
    <van-popup v-model="ckshow"   closeable
               close-icon="close"
               position="bottom" round
               :style="{ height: '40%' }"  >
      <van-form  @submit="cksubmit" >

        <van-field
          v-model="formck.studentnumber"
          name="考生学号"
          label="考生学号"
          placeholder="考生学号"
          readonly
        />

        <van-field
          v-model="formck.studentname"
          name="考生姓名"
          placeholder="考生姓名"
          label="考生姓名"
          readonly
        />

        <van-field
          v-model="formck.sqyy"
          name="申请原因"
          label="申请原因"
          :rules="[{ required: true, message: '请填写申请原因' }]"
        />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>

    </van-popup>
    <!--延时申请-->
    <van-popup v-model="ysshow"   closeable
               close-icon="close"
               position="bottom" round
               :style="{ height: '50%' }"  >
      <van-form  @submit="yssubmit" >
        <van-field
          v-model="formys.studentnumber"
          name="考生学号"
          label="考生学号"
          placeholder="考生学号"
          readonly
        />
        <van-field
          v-model="formys.studentname"
          name="考生姓名"
          placeholder="考生姓名"
          label="考生姓名"
          readonly
        />
        <van-field
          v-model="formys.ystime"
          name="延时时长(分钟)"
          label="延时时长(分钟)"
          :rules="[{ pattern, message: '时长请输入数字' }]"
        />
        <van-field
          v-model="formys.sqyy"
          name="申请原因"
          label="申请原因"
          :rules="[{ required: true, message: '请填写申请原因' }]"
        />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>

    </van-popup>
  </div>
</template>
<script>
  import {Notify} from "vant";
  export default {
    components: {
      Notify,
    },
    data() {
      return {
        list: [],
        loadinglist:[],
        ysshow:false,
        ckshow:false,
        loading:true,
        finished: false,
        pattern:/^(0|\+?[1-9][0-9]*)$/,
        // 查询参数
        queryParams:{
          taskid:null,
          ksmxid:null,
        },
        formck:{
          ksmxid:null,
          studentnumber:null,
          studentname:null,
          sqyy:null,
        },
        formys:{
          ksmxid:null,
          studentnumber:null,
          studentname:null,
          sqyy:null,
          ystime:null,
        },
      }
    },
    created() {
      this.getjkrw();
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      getisks(kssj,jssj)
      {
        var aData = new Date();
        if(this.$moment(kssj).valueOf()<=this.$moment(aData).valueOf()<this.$moment(jssj).valueOf())
        {
          return 1;
        }
        else
        {
          return 0;
        }

      },
      getjkrw()
      {
        let that = this;
        this.queryParams.taskid = this.$route.params.id
        let data = {params:that.queryParams}
        this.$ajax.get('/teacher/invigilator/listksmx',data).then(function (res) {
          if (res.code == 200) {
            that.list = res.rows;
            that.loading = false;
          }
        })
      },
      cksubmit()
      {
        let that =this
        this.$dialog.confirm({
          title: "重考申请",
          message: "确定要提交申请吗？",
          messageAlign: 'center'
        }).then(() => {
          that.$ajax.put("/teacher/invigilator/examresit",that.formck).then(function (res) {
            if (res.code == 200) {
              that.getjkrw();
              Notify({ type: 'success', message: res.msg });
              that.ckshow = false
            }
            else
            {
              let msgss = '管理员未设置重考申请时间，申请失败！';
              if(res.msg!=null && res.msg != '')
              {
                msgss = res.msg;
              }
              Notify({ type: 'danger', message: msgss });
              that.ckshow = false
            }
          })
        }).catch(()=>{
          that.ckshow = false
        })
      },
      yssubmit()
      {
        let that =this
        this.$dialog.confirm({
          title: "延时申请",
          message: "确定要提交申请吗？",
          messageAlign: 'center'
        }).then(() => {
          that.$ajax.put("/teacher/invigilator/examdelay",that.formys).then(function (res) {
            if (res.code == 200) {
              that.getjkrw();
              Notify({ type: 'success', message: res.msg });
              that.ysshow = false
            }
            else
            {
              let msgss = '管理员未设置延时申请，申请失败！';
              if(res.msg!=null && res.msg != '')
              {
                msgss = res.msg;
              }
              Notify({ type: 'danger', message: msgss });
              that.ysshow = false
            }
          })
        }).catch(()=>{
          that.ysshow = false
        })
      },
      ckshowbt(ksmxid,number,name)
      {
        this.formck={
          ksmxid:null,
          studentnumber:null,
          studentname:null,
          sqyy:null,
        }
        this.formck.ksmxid=ksmxid;
        this.formck.studentname=name;
        this.formck.studentnumber=number;
        this.ckshow = true;
      },
      ysshowbt(ksmxid,number,name)
      {
        this.formys={
          ksmxid:null,
          studentnumber:null,
          studentname:null,
          sqyy:null,
          ystime:null,
        }
        this.formys.ksmxid=ksmxid;
        this.formys.studentname=name;
        this.formys.studentnumber=number;
        this.ysshow = true;
      },
      jjsubmit(ksmxid)
      {
        let that =this
        this.$dialog.confirm({
          title: "",
          message: "确定要强制交卷吗？",
          messageAlign: 'center'
        }).then(() => {
        this.$ajax.put("/teacher/invigilator/examsubmit/"+ksmxid).then(function (res) {
          that.getjkrw();
          Notify({ type: 'success', message: res.msg });
        })
        }).catch(()=>{
          that.ysshow = false
        })
      },
      onLoad() {
        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        setTimeout(() => {
          for (let i = 0; i < this.list.length; i++) {
            this.loadinglist.push(this.loadinglist.length + 1);
          }
          // 数据全部加载完成
          if (this.loadinglist.length >= this.list.length) {
            this.finished = true;
          }
        }, 1000);
      },
    }
  }
</script>
<style lang="scss" scoped>
  .listmx{
    margin-top: 4.125rem;
    padding: 0 1.25rem;
    .mxitem{
      background-color: #F8F8F8;
      margin-bottom: .9375rem;
      border-radius: 5px;
      padding: .9375rem 1.25rem;
      h4{
        margin: 0;
        line-height: 1.375rem;
        margin-bottom: .5rem;
      }
      p{
        color: #757DA3;
        font-size: .75rem;
        margin: 0;
        margin-top: .125rem;
        line-height: 1.0625rem;
      }
      .enter{
        color: #757DA3;
        display: flex;
        font-size: .875rem;
        justify-content: space-between;
        padding-top: .9375rem;
        margin-top: .625rem;
        position: relative;
        &::after{
          position: absolute;
          width: calc(100% + 2.5rem);
          left: -1.25rem;
          top: 0;
          content: '';
          height: 1px;
          background-color: #EBEBEB;
        }
      }
      span{
        font-size: .75rem;
        &.ing{
          color: #F86969;
        }
        &.end{
          color: #7469F8;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/teacherpage/jiankaoindex.vue